import React from "react";
import {
  Card,
  Box,
  Typography,
  Chip,
  IconButton,
  Collapse,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { LegendItem } from "./LegendItem";
import { CHECK_CATEGORIES } from "./CheckConstant";

export const LegendCard = () => {
  const [open, setOpen] = React.useState(false);
  return (
    <Card
      variant="outlined"
      sx={{
        mb: 2,
        borderRadius: 2,
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        border: "1px solid #e5e7eb",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2.5,
          py: 1.5,
          backgroundColor: "#f8fafc",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
            variant="h5"
            fontWeight={600}
            sx={{ color: "#1e293b", fontSize: 16 }}
          >
            Check Categories
          </Typography>
          <Chip
            label={CHECK_CATEGORIES.length}
            size="small"
            sx={{
              fontSize: 11,
              height: 18,
              backgroundColor: "#e0e7ef",
              color: "#64748b",
              fontWeight: 500,
            }}
          />
        </Box>
        <IconButton
          onClick={() => setOpen((prev) => !prev)}
          size="small"
          sx={{
            color: "#64748b",
            transition: "transform 0.2s",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
          }}
        >
          <ExpandMoreIcon sx={{ fontSize: 24 }} />
        </IconButton>
      </Box>

      <Collapse in={open} timeout={200} unmountOnExit>
        <Box sx={{ backgroundColor: "#fdfdfd" }}>
          {CHECK_CATEGORIES.map((item, index) => (
            <React.Fragment key={item.key}>
              <LegendItem {...item} />
              {index < CHECK_CATEGORIES.length - 1 && (
                <Divider sx={{ mx: 2, opacity: 0.3 }} />
              )}
            </React.Fragment>
          ))}
        </Box>
      </Collapse>
    </Card>
  );
};
